import { safeJSONParse } from './commonUtils';

export function localStorageSet(key: string, value: unknown) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(error);
  }
}

export function localStorageGet<T>(key: string) {
  try {
    const item = localStorage.getItem(key);
    const value = safeJSONParse(item);
    return value as T;
  } catch (error) {
    console.error(error);
  }
}

export function localStorageRemove(key: string) {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error(error);
  }
}

export function localStorageClear() {
  localStorage.clear();
}
